module.exports = __webpack_public_path__ + "img/file-export.ff30afc3.svg";